import React, { useEffect, useState } from "react";
import PaypalButton from "./../../components/paypal/paypal";

export default function Payment(props) {
  const data = props.data;
  const [checkOut, setCheckOut] = useState(false);

  console.log(data);
  useEffect(() => {}, []);

  return (
    <>
      <h4 className="card-title mb-3">Payment</h4>
      <div className="invoice-card">
        <div className="invoice-details">
          <table className="invoice-table">
            <thead>
              <tr>
                <td>PRODUCT</td>
                <td>PRICE</td>
              </tr>
            </thead>

            <tbody>
              <tr className="row-data">
                <td>
                  Gold Plan
                  {/* <span>(large)</span> */}
                </td>
                <td>$ {Number(data.amount).toFixed(2)}</td>
                {/* <td>$ 20.00</td> */}
              </tr>
            </tbody>
          </table>
        </div>
        <div className="invoice-title">
          <span id="date">Booking Date: {data.booking_date} </span>
          <span id="date" className="pb-1">
            Expiry Date: {data.expiry_date}
          </span>
        </div>

        <div>
          <PaypalButton price={props.data.amount} />
          {/* <h1>Paypal Component</h1> */}
        </div>
      </div>
    </>
  );
}
